export default class Ellipsis {
    #element

    constructor(element) {
        this.#element = element

        new bootstrap.Dropdown(element, {
            popperConfig: {
                boundary: 'window',
                placement: 'bottom-end',
                modifiers: [
                    {
                        name: 'flip',
                        enabled: true,
                    },
                ],
            },
        })

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new Ellipsis(element))
    }

    #bindEvents() {
        this.#element.addEventListener('show.bs.dropdown', (e) => {
            const dropdownParent = this.#element.closest('.ellipsis-menu')

            if (dropdownParent) {
                dropdownParent.classList.add('position-static')
            }
        })

        this.#element.addEventListener('hide.bs.dropdown', () => {
            const dropdownParent = this.#element.closest('.ellipsis-menu')

            if (dropdownParent) {
                dropdownParent.classList.remove('position-static')
            }
        })
    }
}
